<template>
  <div>
    <div class="message" :class="{ me: user.id === message.user_id }">
      <div class="bubble">{{ message.body }}</div>
      <span class="message-date">{{ moment(message.created_at).format('DD.M.YYYY H:mm') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>
